import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { findDOMNode } from 'react-dom';

export default function createDecorator({ store, theme }) {
  return WrappedComponent =>
    class extends Component {
      static propTypes = {
        block: PropTypes.object,
        blockProps: PropTypes.object,
        className: PropTypes.string,
        contentState: PropTypes.object,
      };

      componentDidMount() {
        const selectBlock = store.getItem('selectBlock');
        const isLoading = this.isLoading();

        setTimeout(() => {
          if (isLoading) {
            selectBlock(this.props.block);
            this.updateStore();
          }
        }, 1000);
      }

      componentDidUpdate() {
        this.updateStore();
      }

      componentWillUnmount() {
        store.updateItem('visibleBlock', null);
      }

      isLoading = () => {
        const { block } = this.props;
        const getEditorState = store.getItem('getEditorState');
        const entityKey = block.getEntityAt(0);
        const entity = getEditorState().getCurrentContent().getEntity(entityKey);

        return entity.data.isLoading;
      };

      updateStore = () => {
        const { block, blockProps, contentState } = this.props;

        store.updateItem('editorFocus', blockProps.editorFocus);

        if (blockProps.isFocused && blockProps.isCollapsedSelection) {
          const blockNode = findDOMNode(this);
          const boundingRect = blockNode.getBoundingClientRect();
          const entityKey = block.getEntityAt(0);
          store.updateItem('size', blockProps.size);
          store.updateItem('setSize', blockProps.setSize);
          store.updateItem('alignment', blockProps.alignment);
          store.updateItem('setAlignment', blockProps.setAlignment);
          store.updateItem('setHref', blockProps.setHref);
          store.updateItem('deleteBlock', blockProps.deleteBlock);
          store.updateItem('boundingRect', boundingRect);
          store.updateItem('entityKey', entityKey);
          store.updateItem('entity', contentState.getEntity(entityKey));
          store.updateItem('visibleBlock', block.getKey());
        } else if (store.getItem('visibleBlock') === block.getKey()) {
          store.updateItem('visibleBlock', null);
        }
      };

      render() {
        const { className, blockProps } = this.props;
        const { alignment, size } = blockProps;
        const containerClassName = classNames(className, {
          [theme.alignLeft]: alignment === 'left',
          [theme.alignRight]: alignment === 'right',
          [theme.sizeFullWidth]: size === 'fullWidth',
          [theme.sizeContentWidth]: size === 'content',
          [theme.sizeSmallCenter]: size === 'smallCenter',
          [theme.sizeOriginal]: size === 'original',
        });

        return <WrappedComponent {...this.props} className={containerClassName}/>;
      }
    };
}



// WEBPACK FOOTER //
// ./app/components/text-editor/plugins/media-block/create-decorator.js